'use strict';
const HistoryModel = require('../models/history-model'),
	mmWidgets = require('../widgets/mm-widgets');
require('../widgets/history-events-widget');

module.exports = function (collaborationModel, navigatorShim, pageController) {
	const historyModel = new HistoryModel({collaborationModel, navigatorShim, maxInitialEvents: 1000}),
		initialiseWidgets = function () {
			mmWidgets('[data-mm-sidebar-name=History]').historyEventsWidget({historyModel, pageController, isReadOnly: true});
		};
	return {
		historyModel: historyModel,
		initialiseWidgets: initialiseWidgets
	};
};


